import {setupAnalyticsEvents} from '@github-ui/analytics-behaviors'

setupAnalyticsEvents()
